export default {
	edit: 'Bearbeiten',
	delete: 'Löschen',
	enable: 'Für dieses Szenario aktivieren',
	disable: 'Für dieses Szenario deaktivieren',
	next_step: 'Nächster Schritt',
	skip: 'Überspringen',
	finish_review: 'Überprüfung abschließen',
	skip_review: 'Überprüfung überspringen',
	view: 'Details anzeigen',
	close: 'Schließen',
	cancel: 'Abbrechen',
	send: 'Senden',
	clone: 'Klonen',
	open: 'Öffnen',
	sign_out: 'Abmelden',
	search: 'Suchen',
	save: 'Speichern',
	sort_by_name: 'Nach Name sortieren (A→Z)',
	sort_by_importance: 'Nach Wichtigkeit sortieren (hoch→niedrig)',
	filter_positive: 'Positive Interessengruppen filtern',
	filter_negative: 'Negative Interessengruppen filtern',
	export: {
		excel: 'Als Excel-Datei exportieren',
		image: 'Als Bild exportieren'
	},
	click_to_select: 'Klicken zum Auswählen',
	click_to_drag: 'Ziehen und Ablegen zum Verschieben',
	confirm_drop: {
		message_baseline:
			'Sie aktualisieren die Baseline, bestätigen Sie die Änderungen?',
		message_scenario:
			'Sie aktualisieren das Szenario {{scenarioName}}, bestätigen Sie die Änderungen?',
		likelihood: 'Wahrscheinlichkeit',
		impact: 'Auswirkung',
		before: 'Vorher',
		after: 'Nachher'
	}
};
